import { useIntl } from 'react-intl';
import { useAppSelector } from '../../../app/hooks';
import { fetchLoggedInUserSelector } from '../../selectors';
import { ILoggedInUser } from '../../types';
import SideModalWrapper from '../../Assets/modals/SideModalWrapper';
import JourneyForm from '../JourneyForm/JourneyForm';
import JourneyViewSidePanel from '../components/JourneyViewSidePanel';
import useJourneyStepperContext from '../hooks/useJourneyStepperContext';
import { messages } from '../messages';

const JourneyModal = () => {

    const { formatMessage } = useIntl()
    const { currentStep, goToStep, mode, selectedJourney } = useJourneyStepperContext()
    const { tenantId } = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)

    if (mode === 'view' && currentStep === 3 && selectedJourney && selectedJourney.id) {
        return (
            <JourneyViewSidePanel
                open={true}
                onClose={() => goToStep(0)}
                journeyId={selectedJourney.id}
                tenantId={tenantId}
            />
        )
    }

    return (
        <SideModalWrapper withBottomBox={true} open={currentStep === 3} onClose={() => {
            goToStep(0);
        }} onSave={() => {
            goToStep(0);
        }} headerLabel={formatMessage(messages.createJourney)} width='95%'>
            <JourneyForm />
        </SideModalWrapper>
    );
}

export default JourneyModal
